<template>
  <section class="section">
    <div class="section-header">
      <h1>ยืนยันการลงทะเบียนเรียนให้นักศึกษา</h1>
    </div>
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>ค้นหา/แสดงข้อมูล</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">หมายถึงฟิลด์ที่จำเป็น</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >ระดับการศึกษา
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option>---กรุณาเลือก---</option>
                        <option>0:เรียนบางรายวิชา</option>
                        <option>1:ประกาศนียบัตร</option>
                        <option>2:อนุปริญญา</option>
                        <option selected>3:ปริญญาตรี</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ปีการศึกษา</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>2562</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ภาคการศึกษา</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>2</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>สำนักวิชา</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>---ไม่ระบุ---</option>
                        <option>10:ศิลปศาสตร์</option>
                        <option>11:วิทยาศาสตร์</option>
                        <option>12:การจัดการ</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>สาขาวิชา</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>---ไม่ระบุ---</option>
                        <option>ไม่ระบุ1</option>
                        <option>ไม่ระบุ2</option>
                        <option>ไม่ระบุ3</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>หลักสูตร</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="submit"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                            />
                            <button class="btn btn-danger btn-lg" type="submit">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ชั้นปี</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>---ไม่ระบุ---</option>
                        <option>ไม่ระบุ1</option>
                        <option>ไม่ระบุ2</option>
                        <option>ไม่ระบุ3</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ตั้งแต่ รหัสประจำตัว</label>
                  </div>
                  <div class="col no-margin-padding">
                    <!-- <div class="form-row">
                      <div class="col no-margin-padding" style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 0">
                        <input type="text" class="form-control col mr-2" />
                      </div>
                      <div class="col no-margin-padding" style="flex: 0 0 7em; padding: 5px 0 0 2px;">
                        <v-icon large color="pink">search</v-icon>
                        <v-icon large color="pink">fa-eraser</v-icon>
                      </div>
                      <div class="col no-margin-padding" style="padding-left: 0; padding-top: 0; padding-right: 0">
                        <input type="text" class="form-control col mr-2" />
                      </div>
                    </div> -->
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="submit"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                            />
                            <button class="btn btn-danger btn-lg" type="submit">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ถึง รหัสประจำตัว</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="submit"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                            />
                            <button class="btn btn-danger btn-lg" type="submit">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ตั้งแต่ สถานะนักศึกษา</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>---ไม่ระบุ---</option>
                        <option>10:ปัจจุบัน (ปกติ)</option>
                        <option>ไม่ระบุ2</option>
                        <option>ไม่ระบุ3</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ถึง สถานะนักศึกษา</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>---ไม่ระบุ---</option>
                        <option>10:ปัจจุบัน (ปกติ)</option>
                        <option>ไม่ระบุ2</option>
                        <option>ไม่ระบุ3</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>สถานะการลงทะเบียน</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-group" style="margin-bottom: 0;">
                      <div class="form-inline">
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="customRadioInline1"
                            name="customRadioInline1"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="customRadioInline1"
                            >ไม่ระบุ</label
                          >
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="customRadioInline2"
                            name="customRadioInline1"
                            class="custom-control-input"
                            checked
                          />
                          <label
                            class="custom-control-label"
                            for="customRadioInline2"
                            >ไม่สามารถยืนยันการลงทะเบียนได้ด้วยตนเอง</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button class="btn btn-primary btn-lg">ค้นหา</button
                  >&nbsp;&nbsp;&nbsp;
                  <button class="btn btn-light btn-lg">ล้างหน้าจอ</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label><strong>หมายเหตุ: รหัสประจำตัว</strong></label>
                  </div>
                  <div class="col no-margin-padding">
                    <span class="text-danger"
                      >สีแดง - ยังไม่ได้ลงทะเบียนเรียน/
                      มีรายวิชารอยืนยันลงทะเบียนเรียน </span
                    ><br />
                    สีดำ - ลงทะเบียนเรียนแล้ว/ ไม่มีรายวิชารอลงทะเบียนเรียน
                  </div>
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <div class="table-responsive">
              <table class="table table-striped" id="table-2">
                <thead>
                  <tr>
                    <th class="text-center">ลำดับ</th>
                    <th class="text-center">รหัสประจำตัว</th>
                    <th class="text-center">ชื่อ-นามสกุล</th>
                    <th class="text-center">สาขาวิชา</th>
                    <th class="text-center">ระดับการศึกษา</th>
                    <th class="text-center">สถานะนักศึกษา</th>
                    <th class="text-center">เกรด</th>
                    <th class="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-center">1</td>
                    <td class="text-danger" style="white-space: nowrap">
                      563 1006 048
                    </td>
                    <td style="white-space: nowrap">
                      นาย ทินภัทร วงศ์ธรรมา
                    </td>
                    <td style="white-space: nowrap">ภาษาอังกฤษ</td>
                    <td style="white-space: nowrap">
                      3:ปริญญาตรี ชั้นปี 6
                    </td>
                    <td style="white-space: nowrap">
                      10:ปัจจุบัน (ปกติ)
                    </td>
                    <td class="text-right">
                      1.97
                    </td>
                    <td class="text-center">
                      <v-btn text icon @click="goTo(1)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">2</td>
                    <td style="white-space: nowrap">
                      563 1006 506
                    </td>
                    <td style="white-space: nowrap">
                      นางสาว นฤมล เพ็งโสภา
                    </td>
                    <td style="white-space: nowrap">ภาษาอังกฤษ</td>
                    <td style="white-space: nowrap">
                      3:ปริญญาตรี ชั้นปี 6
                    </td>
                    <td style="white-space: nowrap">
                      10:ปัจจุบัน (ปกติ)
                    </td>
                    <td class="text-right">
                      2.21
                    </td>
                    <td class="text-center">
                      <v-btn text icon @click="goTo(1)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">3</td>
                    <td class="text-danger" style="white-space: nowrap">
                      563 1007 095
                    </td>
                    <td style="white-space: nowrap">
                      นาย พัทธดนย์ เขื่อนสกุลจรัส
                    </td>
                    <td style="white-space: nowrap">ภาษาจีนธุรกิจ</td>
                    <td style="white-space: nowrap">
                      3:ปริญญาตรี ชั้นปี 6
                    </td>
                    <td style="white-space: nowrap">
                      10:ปัจจุบัน (ปกติ)
                    </td>
                    <td class="text-right">
                      1.98
                    </td>
                    <td class="text-center">
                      <v-btn text icon @click="goTo(1)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "tor10",
  data: () => ({
    selected: 0
  }),
  methods: {
    goTo(index) {
      this.selected = index;
      this.$router.push({ name: "register" });
    }
  }
};
</script>
